import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

export interface StudentPortalBranding {
  id: number;
  showBrandText: boolean;
  programTitleEn: string;
  programTitleEs: string;
  programSubtitleEn: string;
  programSubtitleEs: string;
  taglineEn: string;
  taglineEs: string;
  footerDescriptionEn: string;
  footerDescriptionEs: string;
  contactEmail: string;
  contactPhone: string;
  contactAddress: string;
  officeHoursEn: string;
  officeHoursEs: string;
  contactNoteEn: string;
  contactNoteEs: string;
  aboutLinkNameEn: string;
  aboutLinkNameEs: string;
  homeTitleEn: string;
  homeTitleEs: string;
  homeSubtitleEn: string;
  homeSubtitleEs: string;
  showHomeTagline: boolean;
  /** Footer background: "primary" (default), "white", or a future color value. */
  footerBackground: string;
  coursesTitleEn: string;
  coursesTitleEs: string;
  coursesSubtitleEn: string;
  coursesSubtitleEs: string;
  contactPageTitleEn: string;
  contactPageTitleEs: string;
  contactPageSubtitleEn: string;
  contactPageSubtitleEs: string;
  isActive: boolean;
  isActiveLabel: string;
  createdBy: number | null;
  createdByName: string;
  createdOn: string;
  updatedOn: string;
}

export type StudentPortalBrandingFields = Omit<
  StudentPortalBranding,
  | "id"
  | "isActive"
  | "isActiveLabel"
  | "createdBy"
  | "createdByName"
  | "createdOn"
  | "updatedOn"
>;

@Injectable({
  providedIn: "root",
})
export class StudentPortalBrandingApiService {
  private readonly baseUrl = `${environment.apiBaseUrl}/student-portal-branding`;

  constructor(private http: HttpClient) {}

  getActive(): Observable<StudentPortalBranding> {
    return this.http.get<StudentPortalBranding>(this.baseUrl);
  }
}
